export const CustomizeUAPPlacementType = {
  ImageAdPlacementWithImageAsBackground: 'ImageAdPlacementWithImageAsBackground',
  ImageAdPlacementWithRating: 'ImageAdPlacementWithRating',
  ImageAdPlacementWithCTA: 'ImageAdPlacementWithCTA',
  ImageAdPlacementWithPlayIcon: 'ImageAdPlacementWithPlayIcon',

  ImageAdWithLogoPlacementNoImage: 'ImageAdWithLogoPlacementNoImage',
  ImageAdWithLogoPlacementWithImage: 'ImageAdWithLogoPlacementWithImage',

  TextAdPlacement: 'TextAdPlacement',
};
